/* this file added by Bearer Web Developer  */
import { createContext, useContext } from "react";
export type PositionMenu = "top" | "left";
type TodayDeliveriesType = {
  anchorEl: HTMLElement | null;
  positionMenu: PositionMenu;
  openMenu: (el: HTMLElement, position?: PositionMenu) => void;
  closeMenu: () => void;
};
export const TodayDeliveriesContext = createContext<TodayDeliveriesType | null>(null);
export const useTodayDeliveriesMenu = () => {
  const ctx = useContext(TodayDeliveriesContext);
  if (!ctx) throw new Error('useMenu must be used inside MenuProvider');
  return ctx;
};
